var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorImageScoreRecaptcha = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 80,
    viewBox: "0 0 48 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 40,
    r: 24,
    fill: "#FF7F41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8947 49.7351L14.7878 50.6282L24.2615 41.1545L33.7352 50.6282L34.6282 49.7351L25.1545 40.2615L34.6282 30.7878L33.7352 29.8947L24.2615 39.3684L14.7878 29.8947L13.8947 30.7878L23.3684 40.2615L13.8947 49.7351Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorImageScoreRecaptcha);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/errorImageScoreRecaptcha.835374415fda29ce4cf04c165c13009d.svg";